// 不同国家的 套餐/自定义服务/定制化服务 的申请步骤
export const applyStepData = {
  Singapore: {
    COMPANY_INCORPORATION: {
      companyName: { step: "Step1", title: "Company Name" },
      kycQuestionnaire: { step: "Step2", title: "KYC Questionnaire" },
      companyDetails: { step: "Step3", title: "Company Details" },
      upload: { step: "Step4", title: "Upload" },
    },
    SERVICE_TRANSFER: {
      kycQuestionnaire: { step: "Step1", title: "KYC Questionnaire" },
      upload: { step: "Step2", title: "Upload" },
    },
    COMPREHENSIVE_CUSTOMIZED: {
      kycQuestionnaire: { step: "Step1", title: "KYC Questionnaire" },
      upload: { step: "Step2", title: "Upload" },
    },
    FUND_ADMIN_CUSTOMIZED: {
      kycQuestionnaire: { step: "Step1", title: "KYC Questionnaire" },
      upload: { step: "Step2", title: "Upload" },
    },
  },
  Malaysia: {
    COMPANY_INCORPORATION: {
      companyName: { step: "Step1", title: "Company Name" },
      kycQuestionnaire: { step: "Step2", title: "KYC Questionnaire" },
      companyDetails: { step: "Step3", title: "Business Information" },
      upload: { step: "Step4", title: "Upload" },
    },
    SERVICE_TRANSFER: {
      kycQuestionnaire: { step: "Step1", title: "KYC Questionnaire" },
      companyDetails: { step: "Step2", title: "Business Information" },
      upload: { step: "Step3", title: "Upload" },
    },
    COMPREHENSIVE_CUSTOMIZED: {
      kycQuestionnaire: { step: "Step1", title: "KYC Questionnaire" },
      upload: { step: "Step2", title: "Upload" },
    },
  },
};
